import { render } from "./BuyFileInput.vue?vue&type=template&id=88c82652&scoped=true"
import script from "./BuyFileInput.vue?vue&type=script&lang=js"
export * from "./BuyFileInput.vue?vue&type=script&lang=js"

import "./BuyFileInput.vue?vue&type=style&index=0&id=88c82652&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88c82652"]])

export default __exports__